import {
  DEVELOPER_LOG_MAX_PAGE_SIZE,
  developerLogFilterSchema,
  developerLogPageSchema,
} from "@redotech/developer-log-common/filter";
import * as z from "zod";

export const listDeveloperLogs = {
  name: "listDeveloperLogs" as const,
  input: z.object({
    filter: developerLogFilterSchema,
    cursor: z.string().optional(),
    limit: z
      .number()
      .int()
      .positive()
      .max(DEVELOPER_LOG_MAX_PAGE_SIZE)
      .optional(),
  }),
  output: developerLogPageSchema,
};
